import { media, styled } from '@styles';

import { Container } from '../../templates/Container/Container';

export const Wrapper = styled(Container)`
  padding: 210px 0 235px;
  display: flex;
  ${media.largeScreen`
    padding: 120px 0 106px;
  `}
  ${media.mediumScreen`
    padding: 110px 0 101px;
  `}
  ${media.smallScreen`
    flex-direction: column;
    padding: 70px 0 70px;
  `}
`;

export const Title = styled.div`
  padding-left: 164px;
  flex-basis: 52%;
  ${media.largeScreen`
    padding-left: 84px;
    flex-basis: 47%;
  `}
  ${media.mediumScreen`
    padding-left: 15px;
    flex-basis: 43%;
  `}
  ${media.smallScreen`
    flex-basis: 100%;
    padding-left: 0;
  `}
`;

export const H3 = styled.h3`
  font-family: ${(props) => props.theme.typography.thinFontFamily};
  font-size: ${(props) => props.theme.typography.h5FontSize};
  line-height: 110%;
`;

export const Address = styled.div`
  margin-right: 150px;
  ${media.smallScreen`
    margin: 35px 0 35px;
  `}
`;

export const Details = styled.div``;

export const Item = styled.div`
  h4 {
    margin-bottom: 30px;
    font-family: ${(props) => props.theme.typography.thinFontFamily};
    font-size: ${(props) => props.theme.typography.h5FontSize};
    line-height: 110%;
    color: rgba(43, 43, 43, 0.3);
    ${media.largeScreen`
      margin-bottom: 21px;
    `}
    ${media.smallScreen`
      mmargin-bottom: 12px;
    `}
  }
  ul {
    li {
      margin-bottom: 3px;
      font-size: ${(props) => props.theme.typography.baseFontSize};
      line-height: 160%;
      color: rgba(44, 44, 44, 0.8);
      ${media.largeScreen`
        margin-bottom: 0;
      `}
    }
  }
`;
